import { IOrder, ITrackingItem } from '@wyz/types';
import { ORDER_TYPE_CODE } from '@wyz/utils';
import { TranslationKeys } from '~/common/types';

export const ORDER_TYPE_LOOKUP: Record<string, keyof TranslationKeys> = {
  [ORDER_TYPE_CODE.BO]: 'app.common.offer_type.backorder',
  [ORDER_TYPE_CODE.H]: 'app.purchase.order_type.wheel', // Roue complète
  [ORDER_TYPE_CODE.SUBSTITUTION]: 'app.purchase.order_type.substitution',
  [ORDER_TYPE_CODE.REGULATION]: 'app.purchase.order_type.ean_regularization',
  [ORDER_TYPE_CODE.REGULATION_QUANTITY]:
    'app.purchase.order_type.quantity_regularization',
  [ORDER_TYPE_CODE.REFUSAL_TAKE_BACK]:
    'app.purchase.order_type.refusal_take_back', //Reprise/Refus
  [ORDER_TYPE_CODE.DESADV_MANUF]: 'app.purchase.order_type.zero',
  [ORDER_TYPE_CODE.PHONE]: 'app.purchase.order_type.phone', //RC WYZ
  [ORDER_TYPE_CODE.MANUAL]: 'app.purchase.order_type.manual', // Commande manuelle passée par la finance
  [ORDER_TYPE_CODE.CAPTATION]: 'app.purchase.order_type.captation',
  [ORDER_TYPE_CODE.API]: 'app.purchase.order_type.api',
};

export const TRACKING_STATUS_LABEL_LOOKUP: Record<
  ITrackingItem['status'],
  keyof TranslationKeys
> = {
  DELIVERED_TO_RECIPIENT: 'app.tracking_status.delivered_to_recipient',
  IN_TRANSIT_SHIPPING: 'app.tracking_status.in_transit_shipping',
  DROPPED_AT_PICKUP_POINT: 'app.tracking_status.dropped_at_pickup_point',
  OUT_FOR_DELIVERY: 'app.tracking_status.out_for_delivery',
  DELIVERY_INTERRUPTED: 'app.tracking_status.delivery_interrupted',
  PICKED_UP_BY_CARRIER: 'app.tracking_status.picked_up_by_carrier',
  DELIVERY_RESCHEDULED: 'app.tracking_status.delivery_rescheduled',
  LOCATION_CLOSED: 'app.tracking_status.location_closed',
  ADDRESS_ISSUE: 'app.tracking_status.address_issue',
  PICKED_UP_BY_RECIPIENT: 'app.tracking_status.picked_up_by_recipient',
  DELIVERED_TO_THIRD_PARTY: 'app.tracking_status.delivered_to_third_party',
  DELIVERED: 'app.tracking_status.delivered',
  DELIVERY_INCIDENT: 'app.tracking_status.delivery_incident',
  IN_TRANSIT: 'app.tracking_status.in_transit',
  READY_TO_SHIP: 'app.tracking_status.ready_to_ship',
  DELIVERY_SCHEDULED_TODAY: 'app.tracking_status.delivery_scheduled_today',
  PENDING: 'app.tracking_status.pending',
  DELIVERY_FAILED: 'app.tracking_status.delivery_failed',
  REFUSED_RETURNED: 'app.tracking_status.refused_returned',
  AWAITING_CARRIER_INFO: 'app.tracking_status.awaiting_carrier_info',
  TRACKING_CREATED: 'app.tracking_status.tracking_created',
  TRACKING_EXPIRED: 'app.tracking_status.tracking_expired',
  AVAILABLE_AT_RELAY_POINT: 'app.tracking_status.available_at_relay_point',
};

export const ORDER_STATUS_LABEL_LOOKUP: Record<
  IOrder['logisticStatusId'],
  keyof TranslationKeys
> = {
  10: 'app.common.status.waiting', // STATUS_WAITING
  15: 'app.purchase.order_status.send_supplier', // STATUS_SEND_SUPPLIER
  20: 'app.purchase.order_status.approved', // STATUS_APPROVED
  30: 'app.purchase.order_status.delivery_progress', // STATUS_DELIVERY_PROGRESS
  35: 'app.purchase.order_status.delivery_day', // STATUS_DELIVERY_DAY
  40: 'app.purchase.order_status.sent', // STATUS_DELIVERED
  45: 'app.purchase.order_status.finished', // STATUS_FINISHED
  50: 'app.purchase.order_status.canceled_supplier', // STATUS_CANCELED_SUPPLIER
  51: 'app.purchase.order_status.break_supplier', // STATUS_BREAK_SUPPLIER
  60: 'app.purchase.order_status.canceled_client', // STATUS_CANCELED_CLIENT
  61: 'app.purchase.order_status.canceled_buyer', // STATUS_CANCELED_BUYER
  62: 'app.purchase.order_status.canceled_bank', // STATUS_CANCELED_BANK
  70: 'app.purchase.order_status.canceled_wyz', // STATUS_CANCELED_WYZ
};

// Note: we only put what we want to override
export const PROCESSED_ORDER_STATUS_LABEL_LOOKUP: Record<
  IOrder['logisticStatusId'],
  keyof TranslationKeys
> = {
  ...ORDER_STATUS_LABEL_LOOKUP,
  20: 'app.purchase.order_status.processed.accepted', // STATUS_APPROVED
  50: 'app.purchase.order_status.processed.canceled_supplier',
};
